import { graphql } from "gql";

const EDIT_MESSAGE_THREAD_IS_LOCKED_MUTATION = graphql(`
  mutation EditMessageThreadIsLocked($id: ID!, $isLocked: Boolean!) {
    editMessageThread(id: $id, input: { isLocked: $isLocked }) {
      id
      isLocked
      lockedUserId
    }
  }
`);

export default EDIT_MESSAGE_THREAD_IS_LOCKED_MUTATION;
